export default "__VITE_ASSET__879a1ce1__"